import { useEffect, useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useDeviceStore } from "../state/deviceStore"
import { getWaitersForDevice, type WaiterListItem } from "../api/auth"

export default function WaiterPickerPage() {
  const navigate = useNavigate()
  const deviceUuid = useDeviceStore(s => s.deviceUuid)
  const deviceNaziv = useDeviceStore(s => s.deviceNaziv)
  const [waiters, setWaiters] = useState<WaiterListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!deviceUuid) return
    setLoading(true)
    getWaitersForDevice(deviceUuid)
      .then(setWaiters)
      .catch(err => setError(err.message || "Greška pri učitavanju."))
      .finally(() => setLoading(false))
  }, [deviceUuid])

  return (
    <div className="flex-1 flex flex-col p-6">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-slate-800">SADEO Waiter</h1>
        <p className="text-slate-500 mt-1">{deviceNaziv}</p>
      </div>
      <div className="flex-1 max-w-3xl mx-auto w-full">
        <h2 className="text-lg font-semibold text-slate-700 mb-4">Odaberi sebe:</h2>
        {loading && <div className="text-center text-slate-500">Učitavam...</div>}
        {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3">{error}</div>}
        {!loading && waiters.length === 0 && (
          <div className="text-center text-slate-500 mt-8">Nema dodijeljenih konobara za ovaj tablet.</div>
        )}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {waiters.map(w => (
            <button key={w.id} onClick={() => navigate(`/pin/${w.id}`, { state: { username: w.username, ime: w.ime, prezime: w.prezime } })} className="bg-white border border-slate-200 rounded-xl p-6 hover:border-primary-500 active:bg-slate-50 shadow-sm">
              <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-xl font-bold">
                {w.ime.charAt(0)}{w.prezime.charAt(0)}
              </div>
              <div className="text-slate-800 font-semibold">{w.ime}</div>
              <div className="text-slate-500 text-sm">{w.prezime}</div>
            </button>
          ))}
        </div>
      </div>
      <div className="text-center mt-6">
        <Link to="/admin/login" className="text-sm text-slate-400 hover:text-slate-600">Admin login</Link>
      </div>
    </div>
  )
}
